import { AnswerResult, Question } from '@/models/Question';
import { Questionnaire } from '@/models/Questionnaire';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { QuestionnaireState, QuestionnaireTypes } from './types';

const INITIAL_STATE: QuestionnaireState = {
    question: {} as Question,
    questionnnaire: {} as Questionnaire,
    questionnnaires: [] as Questionnaire[],
    responseSummary: [] as AnswerResult[],
    loading: false,
    hasError: false,
    success: false,
    answered: false,
    successOnQuestionnaireList: false,
    successOnFinishQuestionnaire: false,
    successOnStartQuestionnaire: false,
};

const reducer: Reducer<QuestionnaireState> = (state: QuestionnaireState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case QuestionnaireTypes.LIST_QUESTIONNAIRES_REQUEST:
            return { ...state, successOnQuestionnaireList: false, loading: true };
        case QuestionnaireTypes.FINISH_QUESTIONNAIRE_REQUEST:
            return { ...state, loading: true, successOnFinishQuestionnaire: false };
        case QuestionnaireTypes.GENERATE_QUESTIONNAIRE_REQUEST:
        case QuestionnaireTypes.START_QUESTIONNAIRE_REQUEST:
            return { ...state, successOnStartQuestionnaire: false, loading: true };
        case QuestionnaireTypes.GET_QUESTIONNAIRE_REQUEST:
        case QuestionnaireTypes.GET_QUESTION_REQUEST:
        case QuestionnaireTypes.UPDATE_ANSWER_REQUEST:
            return { ...state, loading: false };
        case QuestionnaireTypes.GET_QUESTIONNAIRE_RESULT_REQUEST:
            return { ...state, loading: true };
        case QuestionnaireTypes.GENERATE_QUESTIONNAIRE_FAILURE:
        case QuestionnaireTypes.GET_QUESTIONNAIRE_FAILURE:
        case QuestionnaireTypes.GET_QUESTION_FAILURE:
        case QuestionnaireTypes.UPDATE_ANSWER_FAILURE:
        case QuestionnaireTypes.GET_QUESTIONNAIRE_RESULT_FAILURE:
            return { ...state, hasError: true, loading: false };
        case QuestionnaireTypes.FINISH_QUESTIONNAIRE_FAILURE:
            return { ...state, successOnFinishQuestionnaire: false, hasError: true, loading: false };
        case QuestionnaireTypes.START_QUESTIONNAIRE_FAILURE:
            return { ...state, successOnStartQuestionnaire: false, hasError: true, loading: false };
        case QuestionnaireTypes.LIST_QUESTIONNAIRES_FAILURE:
            return { ...state, successOnQuestionnaireList: false, hasError: true, loading: false };

        case QuestionnaireTypes.LIST_QUESTIONNAIRES_SUCCESS:
            return {
                ...state,
                questionnnaires: action.payload,
                success: true,
                hasError: false,
                loading: false,
                successOnQuestionnaireList: true,
            };
        case QuestionnaireTypes.GET_QUESTIONNAIRE_SUCCESS:
            return { ...state, questionnnaire: action.payload, answered: false, hasError: false, loading: false };
        case QuestionnaireTypes.START_QUESTIONNAIRE_SUCCESS:
            return { ...state, questionnnaire: action.payload, successOnStartQuestionnaire: true, answered: false, hasError: false, loading: false };
        case QuestionnaireTypes.GET_QUESTION_SUCCESS:
            return { ...state, question: action.payload, hasError: false, loading: false };
        case QuestionnaireTypes.GET_QUESTION_CLEAR:
            return { ...state, question: {} as Question };
        case QuestionnaireTypes.GET_QUESTIONNAIRE_RESULT_SUCCESS:
            return { ...state, responseSummary: action.payload, hasError: false, loading: false };
        case QuestionnaireTypes.FINISH_QUESTIONNAIRE_SUCCESS:
            return { ...state, loading: false, successOnFinishQuestionnaire: true };
        case QuestionnaireTypes.UPDATE_ANSWER_SUCCESS:
            return {
                ...state,
                hasError: false,
                answered: true,
                loading: false,
            };
        case QuestionnaireTypes.CLEAR_QUESTIONNAIRE_STORE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default reducer;
